import React from "react";
import { useLang } from "@/contexts/LangContext";
import PageMeta from "@/components/PageMeta";

export default function DatenschutzPage() {
  const { t } = useLang();
  return (
    <div className="pt-32 pb-24" data-testid="privacy-page">
      <PageMeta pageKey="privacy" />
      <section className="max-w-screen-md mx-auto px-6 md:px-12">
        <p className="text-xs tracking-[0.3em] uppercase text-white/50 mb-6">{t("privacy.eyebrow")}</p>
        <h1 className="font-display text-4xl md:text-6xl font-light uppercase tracking-tighter leading-[0.95] mb-12">
          {t("privacy.title")}
        </h1>

        <div className="space-y-10 text-white/75 leading-relaxed">
          <Section title="1. Verantwortlicher">
            <p>
              Royalhouse Bauträger GmbH, Bäckerstraße 2/23, A-1010 Wien, Österreich.
              <br />
              UID: ATU77490127 · Tel.{" "}
              <a className="rh-link" href="tel:+436643289599">+43 664 328 95 99</a>
              <br />
              Kontakt:{" "}
              <a className="rh-link" href="mailto:office@royalhouse-building.eu">
                office@royalhouse-building.eu
              </a>
            </p>
          </Section>

          <Section title="2. Verarbeitete Daten">
            <p>
              Wir verarbeiten ausschließlich jene Daten, die Sie uns über das
              Kontaktformular übermitteln: Vor- und Nachname, E-Mail-Adresse,
              Telefonnummer (optional), Wohnungsgröße, Preisbereich und Nachricht.
              Zusätzlich erfasst der Server Logdaten (IP, Zeitpunkt) ausschließlich
              zur Sicherheits- und Missbrauchsabwehr.
            </p>
          </Section>

          <Section title="3. Zweck & Rechtsgrundlage">
            <p>
              Verarbeitung zur Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. b DSGVO —
              vorvertragliche Maßnahmen) sowie zur Wahrung berechtigter Interessen
              an einer sicheren Bereitstellung des Online-Angebots (Art. 6 Abs. 1
              lit. f DSGVO).
            </p>
          </Section>

          <Section title="4. Speicherdauer">
            <p>
              Anfragen speichern wir maximal 24 Monate nach letzter Kommunikation,
              soweit gesetzliche Aufbewahrungsfristen nichts anderes vorschreiben.
              Login-Versuche werden nach 30 Tagen anonymisiert.
            </p>
          </Section>

          <Section title="5. Empfänger">
            <p>
              Eine Weitergabe Ihrer Daten erfolgt nur an: (a) interne Mitarbeiter zur
              Bearbeitung der Anfrage, (b) E-Mail-Versanddienstleister Resend
              (Belgien/USA · DPA vorhanden), (c) MongoDB-Hostingdienstleister.
            </p>
          </Section>

          <Section title="6. Ihre Rechte">
            <p>
              Sie haben jederzeit Recht auf Auskunft, Berichtigung, Löschung,
              Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch
              gemäß DSGVO. Beschwerden können Sie bei der Österreichischen
              Datenschutzbehörde (
              <a
                className="rh-link"
                href="https://www.dsb.gv.at"
                target="_blank"
                rel="noreferrer noopener"
              >
                dsb.gv.at
              </a>
              ) einreichen.
            </p>
          </Section>

          <Section title="7. Cookies">
            <p>
              Diese Website verwendet ausschließlich technisch notwendige Cookies
              (Session, Sprach-Präferenz). Es findet kein Tracking durch Drittanbieter
              statt.
            </p>
          </Section>

          <Section title="8. Kontakt für Datenschutzfragen">
            <p>
              <a className="rh-link" href="mailto:office@royalhouse-building.eu">
                office@royalhouse-building.eu
              </a>
            </p>
          </Section>
        </div>
      </section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <p className="text-[11px] tracking-[0.25em] uppercase text-white/50 mb-3">{title}</p>
      <div className="text-base">{children}</div>
    </div>
  );
}
